import React, { useState } from "react";
import MobileHeaderImage from "../Assets/Images/Mobile-logo-auth.svg";
import AppStoreIcon from "../Assets/Images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917 1.svg";
import GooglPlayIcon from "../Assets/Images/GetItOnGooglePlay_Badge_Web_color_English 1.svg";

const detectDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  } else if (/huawei/i.test(userAgent)) {
    return "Huawei";
  } else if (/android/i.test(userAgent)) {
    return "Android";
  } else if (/windows phone/i.test(userAgent)) {
    return "WindowsPhone";
  } else {
    return "Other";
  }
};

const MobileView = () => {
  const [deviceType] = useState(detectDevice);
  const [modal, setModal] = useState({
    visible: false,
    title: "",
    message: "",
  });

  const showModal = (title, message) => {
    setModal({
      visible: true,
      title,
      message,
    });
  };

  const closeModal = () => {
    setModal({
      visible: false,
      title: "",
      message: "",
    });
  };

  const handleAppleClick = () => {
    if (deviceType === "iOS") {
      window.location.assign(
        "https://apps.apple.com/us/developer/weddingly-llc/id1758537679"
      );
    } else {
      showModal(
        "Unsupported Device",
        "It looks like you are not using an iOS device. Please use an Apple device to download from the App Store."
      );
    }
  };
  const handleGoogleClick = () => {
    if (deviceType === "Android") {
      window.location.assign(
        "https://play.google.com/store/apps/details?id=com.weddingly.weddinglymobile"
      );
    } else if (deviceType === "Huawei") {
      showModal(
        "Google Play Not Supported",
        "It looks like your device may not support the Google Play Store. Please check the Huawei AppGallery or visit our website for more options."
      );
    } else {
      showModal(
        "Unsupported Device",
        "It looks like you are not using an Android device. Please use an Android device to download from the Google Play Store."
      );
    }
  };

  return (
    <div className="mobile-view-wrapper">
      <div className="mobile-view">
        <img
          src={MobileHeaderImage}
          alt="main-logo"
          className="mobile-view--icon"
        />
        <p className="mobile-view--text">
          You're viewing WeddinglyAi on a smaller screen. For the best
          experience, we recommend using our mobile app.
        </p>
        <div className="mobile-view__action">
          <img
            src={AppStoreIcon}
            alt="apple-icon"
            className="mobile-view__action--icon"
            onClick={handleAppleClick}
          />
          <img
            src={GooglPlayIcon}
            alt="google-icon"
            className="mobile-view__action--icon"
            onClick={handleGoogleClick}
          />
        </div>

        {modal.visible && (
          <>
            <div className="modal-overlay" onClick={closeModal}></div>
            <div className="modal-content">
              <h2>{modal.title}</h2>
              <p>{modal.message}</p>
              <a href="#" onClick={closeModal}>
                Close
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MobileView;
